module.exports = __webpack_public_path__ + "img/Dr-soft — full.04040929.png";